import * as S from './ComplexesList.styled';
import { useSelector } from 'react-redux';
import Table from './components/Table';
import { useAppDispatch } from 'hooks/useStore';
import { IsOwnerSelector } from 'features/User/UserSlice';
import {
  ComplexesListItemsSelector,
  removeComplex,
} from './ComplexesListSlice';
import { JSX } from 'react/jsx-runtime';
import { openEditComplexModal } from 'features/EditComplexModal/EditComplexModalSlice';

const LotsList = (): JSX.Element => {
  const dispatch = useAppDispatch();

  // Список застройщиков
  const complexes = useSelector(ComplexesListItemsSelector);

  // Владелец приложения
  const isOwner = useSelector(IsOwnerSelector);

  // Открытие модалки с карточкой сервис. сентра для редактирования
  const onOpenOldComplexModal = (complexId: number) =>
    dispatch(openEditComplexModal(complexId));

  // Открытие модалки с карточкой сервис. сентра для редактирования
  const onRemoveComplex = (complexId: number) =>
    dispatch(removeComplex(complexId));

  return (
    <S.Wrap>
      <Table
        items={complexes}
        isDisabled={!isOwner}
        onEdit={onOpenOldComplexModal}
        onRemove={onRemoveComplex}
      />
    </S.Wrap>
  );
};

export default LotsList;
